import {ActivityCommonProperties} from "./activity-common-properties";
import {ActivityFlightState} from "./activity-flight";
import {ActivityHotelState} from "./activity-hotel";
import {FlightCalculationRequestLeg} from "../api/model/activity-flight";
import {HotelCalculationRequest} from "../api/model/activity-hotel";
import {Same} from "./index";
import {FlightCalculatedEmissionsResponse} from "../api/model/emissions";
import {ActivityCarBusState} from "./activity-car-bus";
import {CarBusCalculationRequest} from "../api/model/activity-car-bus";

/**
 * Each Activity that the FE and BE can handle is listed in this enum.
 */
export enum ACTIVITY_TYPE {
    flight = "flight",
    hotel = "hotel",
    car_bus = "car_bus"
}

/**
 * Groups into which the Activities can be categorized into.
 */
export enum TRAVEL_OPTION_TYPE {
    transport = "transport",
    accommodation = "accommodation",
    undertaking = "undertaking",
}

export interface AnotherStateToBeFilled extends ActivityCommonProperties {
    common: ActivityCommonProperties["common"] & { totalEmissions: FlightCalculatedEmissionsResponse[] | null }
}

/**
 * Mapping of Activities to Travel Options. A "helper" interface only used to create AllActivityTypes.
 */
export interface TravelOptionToActivitiesMap {
    [TRAVEL_OPTION_TYPE.transport]: (ActivityFlightState | ActivityCarBusState)[],
    [TRAVEL_OPTION_TYPE.accommodation]: (ActivityHotelState)[],
    [TRAVEL_OPTION_TYPE.undertaking]: (AnotherStateToBeFilled)[]
}

/**
 * A helper type used to create AllActivityTypes
 */
export type AllActivitiesValues<T> = T[keyof T]

/**
 * Common type for usage in the FE.
 */
export type AllActivityTypes = AllActivitiesValues<TravelOptionToActivitiesMap>[0]

/**
 * Common type for usage in the FE
 */
export type AllActivityTypesArray = AllActivityTypes[]

/**
 * All possible request type that are send to the BE for calculation
 */
export type ActivityRequestTypes = (HotelCalculationRequest | FlightCalculationRequestLeg | CarBusCalculationRequest)

/**
 * Helper used to for VerifyMapTravelOptionTypeToActivityMappingProps and as a type for TravelOptionTypeToActivityMappingObject.
 */
export type TravelOptionTypeToActivityMappingProps = {
    [TRAVEL_OPTION_TYPE.transport]: [ACTIVITY_TYPE.flight, ACTIVITY_TYPE.car_bus]
    [TRAVEL_OPTION_TYPE.accommodation]: [ACTIVITY_TYPE.hotel]
    [TRAVEL_OPTION_TYPE.undertaking]: []
}

/**
 *  Checks if all available ActivityTypes are mapped to a TravelOptionType
 */
type VerifyMapTravelOptionTypeToActivityMappingProps =
    Same<keyof TravelOptionTypeToActivityMappingProps, TRAVEL_OPTION_TYPE> &
    Same<TravelOptionTypeToActivityMappingProps[keyof TravelOptionTypeToActivityMappingProps][number], ACTIVITY_TYPE>

export const TravelOptionTypeToActivityMappingObject: TravelOptionTypeToActivityMappingProps = {
    [TRAVEL_OPTION_TYPE.transport]: [ACTIVITY_TYPE.flight, ACTIVITY_TYPE.car_bus],
    [TRAVEL_OPTION_TYPE.accommodation]: [ACTIVITY_TYPE.hotel],
    [TRAVEL_OPTION_TYPE.undertaking]: [],
}

export const validActivityTypes = Object.values(ACTIVITY_TYPE) as Array<`${ACTIVITY_TYPE}`>;
export type ActivityTypeStrings = (typeof validActivityTypes)[number];